import { useEffect } from 'react'

const { REACT_APP_PRODUCT_NAME } = process.env

function useDocumentTitle(pageName: string): void {
  useEffect(() => {
    document.title = `${REACT_APP_PRODUCT_NAME} | ${pageName}`
  }, [pageName])
}

export default useDocumentTitle
